 const HowItWorkData=[
    {
        id:1,
        img:"./assests/images/job-valuation.png",
        title:"Job Valuation",
        desc:"Categorising problems with grammar, structure, formatting or referencing of your papers."
    },
    {
        id:2,
        img:"./assests/images/allocating-dedicated-editor.png",
        title:"Job Valuation",
        desc:"Categorising problems with grammar, structure, formatting or referencing of your papers."
    },
    {
        id:3,
        img:"./assests/images/paper-delivery.png",
        title:"Job Valuation",
        desc:"Categorising problems with grammar, structure, formatting or referencing of your papers."
    },
    {
        id:4,
        img:"./assests/images/feedback-completion.png",
        title:"Job Valuation",
        desc:"Categorising problems with grammar, structure, formatting or referencing of your papers."
    },

]

export default HowItWorkData